/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IBloodBank } from 'app/shared/model/blood-bank.model';
import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';

export interface IBloodBankEmployee {
  id?: string;
  education?: string | null;
  training?: string | null;
  experience?: string | null;
  achievements?: string | null;
  name?: string | null;
  email?: string | null;
  dateOfBirth?: number | null;
  gender?: keyof typeof Gender | null;
  bloodGroup?: keyof typeof BloodGroup | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  bloodBank?: IBloodBank | null;
  user?: IUser | null;
  contactDetails?: IContactDetails | null;
}

export const defaultValue: Readonly<IBloodBankEmployee> = {
  active: false,
};
